import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Breadcrumb as ShadcnBreadcrumb,
} from "@/components/shadcn/breadcrumb";
import { useVendorContext } from "@/contexts/vendor-context";
import useUniversalRouter from "@/hooks/use-universal-router";
import navItems, { getActivePageIds, getNavLabel } from "@/utils/navigation";
import Link from "next/link";
import { Fragment } from "react";

const Breadcrumb = () => {
  const { selectedVendor } = useVendorContext();
  const { pathname, asPath } = useUniversalRouter();
  const [activePageId, activeSubPageId] = getActivePageIds(pathname);

  const { subItems } = navItems.find(({ id }) => id === activePageId) || {
    subItems: [],
  };
  const isFirstPage =
    subItems.findIndex(({ id }) => id === activeSubPageId) < 1;

  if (!selectedVendor) return null;

  const items: { href?: string; name: string }[] = [];

  const levels = asPath.split("/").length - 1;

  if (!isFirstPage) {
    items.push({
      href: undefined,
      name: activePageId.replace("_", " "),
    });
  }

  if ((isFirstPage && levels > 2) || levels > 3) {
    const link =
      activePageId !== activeSubPageId
        ? `${activePageId}/${activeSubPageId.replace("_", "-")}`
        : activePageId;

    items.push({
      href: `/${selectedVendor}/${link}`,
      name: activeSubPageId.replace("_", " "),
    });
  }

  return (
    <>
      {items.length > 1 ? (
        <ShadcnBreadcrumb>
          <BreadcrumbList>
            {items.map(({ href, name }, i) => (
              <Fragment key={`${href}_${i}`}>
                {i !== 0 && <BreadcrumbSeparator />}
                <BreadcrumbItem>
                  {href ? (
                    <BreadcrumbLink asChild>
                      <Link href={href} className="capitalize">
                        {getNavLabel(name)}
                      </Link>
                    </BreadcrumbLink>
                  ) : (
                    <BreadcrumbPage>{getNavLabel(name)}</BreadcrumbPage>
                  )}
                </BreadcrumbItem>
              </Fragment>
            ))}
          </BreadcrumbList>
        </ShadcnBreadcrumb>
      ) : (
        <ShadcnBreadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage className="text-muted-foreground capitalize">
                {activePageId}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </ShadcnBreadcrumb>
      )}
    </>
  );
};

export default Breadcrumb;
